import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

interface ProgettoModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const ProgettoModal = ({ isOpen, onClose }: ProgettoModalProps) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
      <div
        className="absolute inset-0 bg-black/60 backdrop-blur-sm"
        onClick={onClose}
      />
      <div className="relative bg-ivory-50 rounded-2xl max-w-2xl w-full max-h-[85vh] overflow-y-auto">
        <div className="sticky top-0 bg-ivory-50 px-8 pt-8 pb-4 border-b border-ivory-200 flex items-center justify-between">
          <h2 className="font-serif text-2xl text-anthracite-800">{t('progetto.title')}</h2>
          <button
            onClick={onClose}
            className="w-9 h-9 flex items-center justify-center rounded-full border border-anthracite-200 text-anthracite-500 hover:border-terracotta-300 hover:text-terracotta-300 transition-all cursor-pointer"
          >
            <i className="ri-close-line"></i>
          </button>
        </div>

        <div className="px-8 py-6 space-y-6">
          <div>
            <h3 className="font-serif text-lg text-anthracite-700 mb-3">{t('progetto.sintesi.title')}</h3>
            <p className="font-sans text-sm text-anthracite-500 leading-relaxed">{t('progetto.sintesi.text')}</p>
          </div>
          <div>
            <h3 className="font-serif text-lg text-anthracite-700 mb-3">{t('progetto.obiettivi.title')}</h3>
            <p className="font-sans text-sm text-anthracite-500 leading-relaxed">{t('progetto.obiettivi.text')}</p>
          </div>
          <div>
            <h3 className="font-serif text-lg text-anthracite-700 mb-3">{t('progetto.risultati.title')}</h3>
            <p className="font-sans text-sm text-anthracite-500 leading-relaxed">{t('progetto.risultati.text')}</p>
          </div>

          {/* FSE+ logos */}
          <div className="bg-anthracite-800 rounded-xl p-6">
            <div className="flex flex-wrap items-center justify-center gap-4 mb-4">
              {['COESIONE ITALIA 2021-2027', 'UNIONE EUROPEA', 'REPUBBLICA ITALIANA', 'REGIONE MARCHE FSE+'].map((logo) => (
                <div key={logo} className="bg-white/10 border border-white/20 rounded px-3 py-2 text-center">
                  <p className="font-sans text-xs font-semibold text-white leading-snug">{logo}</p>
                </div>
              ))}
            </div>
            <p className="font-sans text-xs text-white/60 text-center leading-relaxed">
              {t('footer.fse.text')}
            </p>
          </div>
        </div>

        <div className="px-8 pb-8">
          <button
            onClick={onClose}
            className="w-full py-3 bg-terracotta-300 text-white font-sans text-sm tracking-widest uppercase rounded-full hover:bg-terracotta-400 transition-colors cursor-pointer whitespace-nowrap"
          >
            {t('progetto.close')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProgettoModal;
